import { useMemo } from "react";

import {
  LogoAzureColored,
  LogoBitbucketColored,
  LogoCursorColored,
  LogoRawGitColored,
  LogoGithub,
  LogoGitlabColored,
  LogoSpaceliftColored,
  Package,
} from "components/icons/generated";
import { VcsProvider } from "types/generated";
import { HUMANIZE_PROVIDER } from "constants/vcsProviders";
import useOriginFlag from "hooks/useOriginFlag";

const vcsProviderConfig = [
  {
    type: VcsProvider.Github,
    name: HUMANIZE_PROVIDER[VcsProvider.Github],
    logo: LogoGithub,
  },
  {
    type: VcsProvider.Origin,
    name: HUMANIZE_PROVIDER[VcsProvider.Origin],
    logo: LogoCursorColored,
  },
  {
    type: VcsProvider.GithubEnterprise,
    name: HUMANIZE_PROVIDER[VcsProvider.GithubEnterprise],
    logo: LogoGithub,
  },
  {
    type: VcsProvider.Git,
    name: HUMANIZE_PROVIDER[VcsProvider.Git],
    logo: LogoRawGitColored,
  },
  {
    type: VcsProvider.Gitlab,
    name: HUMANIZE_PROVIDER[VcsProvider.Gitlab],
    logo: LogoGitlabColored,
  },
  {
    type: VcsProvider.AzureDevops,
    name: HUMANIZE_PROVIDER[VcsProvider.AzureDevops],
    logo: LogoAzureColored,
  },
  {
    type: VcsProvider.BitbucketCloud,
    name: HUMANIZE_PROVIDER[VcsProvider.BitbucketCloud],
    logo: LogoBitbucketColored,
  },
  {
    type: VcsProvider.BitbucketDatacenter,
    name: HUMANIZE_PROVIDER[VcsProvider.BitbucketDatacenter],
    logo: LogoBitbucketColored,
  },
  {
    type: VcsProvider.Spacelift,
    name: HUMANIZE_PROVIDER[VcsProvider.Spacelift],
    logo: LogoSpaceliftColored,
  },
  {
    type: VcsProvider.Blob,
    name: HUMANIZE_PROVIDER[VcsProvider.Blob],
    logo: Package,
  },
];

export const useVcsProviderConfig = (supportedProviders?: VcsProvider[]) => {
  const originEnabled = useOriginFlag();

  const vcsProviderConfigFiltered = useMemo(
    () =>
      supportedProviders
        ? vcsProviderConfig.filter(
            ({ type }) =>
              supportedProviders.includes(type) && (type !== VcsProvider.Origin || originEnabled)
          )
        : [],
    [supportedProviders, originEnabled]
  );

  return vcsProviderConfigFiltered;
};
